import * as tagsActions from './tagsActions';
import tagsReducer from './tagsReducer';
import tagsSagas, { tagsDumpUpdater, tagsNudgeUpdater } from './tagsSagas';
import * as tagsSelectors from './tagsSelectors';
import * as tagsTypes from './tagsTypes';

const { TAGS_REDUCER_KEY } = tagsTypes;

export {
  TAGS_REDUCER_KEY,
  tagsActions,
  tagsDumpUpdater,
  tagsNudgeUpdater,
  tagsReducer,
  tagsSagas,
  tagsSelectors,
  tagsTypes,
};
